/* unplugin-vue-components disabled */import script from "./notive.vue?vue&type=script&setup=true&lang=js"
export * from "./notive.vue?vue&type=script&setup=true&lang=js"

import "./notive.vue?vue&type=style&index=0&id=33a17ded&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/48tk_gai/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a17ded"]])

export default __exports__